import { Component, OnInit } from '@angular/core';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { PDxSystemSettingType, SettingInformation } from '../models/setting-information.model';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsPropertiesComponent } from '../settings-properties/settings-properties.component';
import { CloneService } from 'src/app/core/services/clone.service';
import { DirtyTrackingService } from 'src/app/core/dirty-tracking/dirty-tracking.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styles: [
  ]
})
export class SettingsComponent implements OnInit {

  settingList: SettingInformation[] = [];
  pdxSystemSettingType = PDxSystemSettingType;

  constructor(private ajax: ajaxCall,
    private cloneService: CloneService,
    private dirtyService: DirtyTrackingService,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.loadSettings();
  }

  loadSettings(): void {
    this.ajax.MakeCall<SettingInformation[]>('/Setting/Get').then((data) => {
      this.settingList = data;
    }, () => { });
  };

  editSettings(s: SettingInformation): void {
    const modal = this.modalService.open(SettingsPropertiesComponent, { beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.setting = this.cloneService.deepClone(s);
    modal.result.then(() => { this.loadSettings(); }, () => { });
  }
}
